import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AdjacentType, CustomerAccountType, DeviceState } from '@iotv/datamodel-core';
import { AppValueTypes, ComparisonType, LogicalOperatorType } from '@iotv/iotv-v3-types';
import { Avatar, Badge, Box, Button, CardHeader, Typography } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import AppDao from '../../../data/AppDao';
import { getCustomerHierarchy } from '../../../data/RoleQueries';
import { useSelectedObjects } from '../../../hooks/useSelectedObjects';
import { ComponentMode, ObjectViewType } from '../../../types/AppTypes';
import { ListerlizerAdapter } from '../../factories/Listerlizer/legacy/ListerlizerAdapter';
import ModalContainer from '../../Modal/ModalContainer';
import NavLink from '../../navigation/NavLink';
import { NavSections } from '../../navigation/NavSections';
import ProvisionCard from './ProvisionCard';
const getJoinedDevices = async (customer) => {
    const res = await AppDao.queryByGraph({
        contextObjects: [customer],
        path: [{ objectTypeId: 'Group', adjacencyType: AdjacentType.CHILD }],
    });
    if (res.err === null && res.data !== null) {
        const deviceGroups = res.data.getContainedItems().filter((device) => device.supportedType === 'Device');
        const wantedGroup = deviceGroups.filter((group) => group.name === 'All Devices');
        if (wantedGroup.length === 1) {
            return wantedGroup[0];
        }
        else {
            console.error('Invalid Group Count Found');
            console.error('Found', deviceGroups);
            console.error('Wanted', wantedGroup);
        }
    }
};
/** @deprecated - Not used anymore */
const DeviceAssignmentCard = (props) => {
    const { contextCustomer, user, userFunctions, transactionFunctions } = props;
    const { state: [[selectedObjects, setSelectedObjects]], } = useSelectedObjects();
    const [sourceCustomer, setSourceCustomer] = useState();
    const [sourceGroup, setSourceGroup] = useState();
    const [childCustomers, setChildCustomers] = useState();
    const [provisionModal, setProvisionModal] = useState(false);
    const getDeviceListilizer = (context) => {
        const baseQueryFilter = [
            {
                filters: [{ key: 'state', value: DeviceState.INVENTORY, predicate: ComparisonType.EQUALS }],
                setOperation: LogicalOperatorType.AND,
            },
        ];
        return {
            initMode: ComponentMode.EDIT,
            transactionFunctions,
            userFunctions,
            adjacentFilter: {
                adjacentType: AdjacentType.CHILD,
                objectType: 'Device',
                filterConfig: baseQueryFilter,
            },
            autoQuery: true,
            columnVisibilityReferences: {
                dataTableReference: 'List',
                objectTypeId: 'ValidBusinessObject',
                viewType: ObjectViewType.List,
                externalColumnVisibility: undefined,
            },
            viewDefinition: {
                name: {
                    key: 'name',
                    type: AppValueTypes.STRING,
                    label: 'Devices',
                    editable: false,
                    precision: undefined,
                    stateFn: undefined,
                    unit: undefined,
                    validationRx: undefined,
                    enumKV: undefined,
                },
                state: {
                    key: 'state',
                    type: AppValueTypes.STRING,
                    label: 'State',
                    editable: false,
                    precision: undefined,
                    stateFn: undefined,
                    unit: undefined,
                    validationRx: undefined,
                    enumKV: undefined,
                },
            },
            viewObject: {
                matchedPrimary: context,
                matchedRelatedByPk: [],
                matchedRelatedBySk: [],
            },
            contextObject: context,
            searchRootObject: context,
            selectorConfigParams: {
                controls: {
                    add: false,
                    find: false,
                },
            },
            onSelectedUpdate: setSelectedObjects,
        };
    };
    //gets v level
    useEffect(() => {
        const getCustomers = async (customer) => {
            const customerHier = await getCustomerHierarchy(customer);
            if (customerHier.err === null && customerHier.data !== null) {
                const topCustomer = customerHier.data.nodes.filter((customer) => customer.accountType === CustomerAccountType.V);
                if (topCustomer.length === 1) {
                    setSourceCustomer(topCustomer[0]);
                }
                else {
                    setSourceCustomer(undefined);
                    console.error('Top customer with ambiguity found');
                }
            }
            else {
                setSourceCustomer(undefined);
                console.error('Somehow, customer hierarchy did not get anything');
            }
        };
        if (contextCustomer) {
            getCustomers(contextCustomer);
        }
        else {
            setSourceCustomer(undefined);
        }
    }, [contextCustomer]);
    useEffect(() => {
        if (sourceCustomer) {
            getJoinedDevices(sourceCustomer).then((res) => {
                setSourceGroup(res);
            });
            getCustomerHierarchy(sourceCustomer).then((customersResponse) => {
                if (customersResponse.err === null && customersResponse.data !== null) {
                    let options = customersResponse.data.nodes;
                    options = options.filter((option) => option.id !== sourceCustomer.id);
                    setChildCustomers(options);
                }
                else {
                    console.error('No customers found');
                    setChildCustomers([]);
                }
            });
        }
    }, [sourceCustomer]);
    const closeProvisioning = useCallback(() => {
        setProvisionModal(false);
    }, []);
    const openProvisioning = useCallback(() => {
        setProvisionModal(true);
    }, []);
    return (_jsxs("div", { children: [_jsx(Box, { sx: {
                    m: 2,
                }, children: _jsx(Typography, { component: "h5", variant: "h5", children: "Device Assignment" }) }), _jsx(CardHeader, { avatar: _jsx(NavLink, { filter: `${NavSections.DEVICE_ASSIGNMENT}`, children: _jsx(Badge, { color: "primary", children: _jsx(Avatar, { "aria-label": "recipe", children: sourceGroup ? (sourceGroup.name ? sourceGroup.name.substr(0, 1).toUpperCase() : `${sourceGroup.type} ?`) : '??' }) }) }), title: sourceGroup?.name }), _jsx(Button, { variant: "contained", color: "primary", disabled: selectedObjects.length === 0, onClick: openProvisioning, children: "Allocate" }), sourceGroup && _jsx(ListerlizerAdapter, { ...getDeviceListilizer(sourceGroup) }), provisionModal && childCustomers && contextCustomer && user && (_jsx(ModalContainer, { children: _jsx(ProvisionCard, { customerOptions: childCustomers,
                    user,
                    devices: selectedObjects,
                    close: closeProvisioning,
                    contextCustomer,
                    userFunctions,
                    transactionFunctions }) }))] }));
};
export default DeviceAssignmentCard;
